import React from 'react'

import Routes from 'components/Routes'

import { ContentContainer } from './style'

export default function Content() {
  return (
    <ContentContainer>
      <Routes />
    </ContentContainer>
  )
}
